import {
  CondensedHeader,
  Flashy,
  Gutter,
  Icon,
  ImageCircle,
  Layout,
  LayoutItem,
  List,
  ListItem,
  ParagraphHeader,
  Visible,
  Well,
} from '@axiom/ui';
import React from 'react';

import type { TalentPartnerUser } from './SupportContactsModal';

const helpItems = [
  'Reviewing and improving your profile copy',
  'Help with Action Needed items',
  'Questions about how Axiom works - including the Waitlist and what to expect between engagements',
  'What to expect as an engagement starts or approaches its renewal date',
];

export const SupportContactsModalProfileHelp = ({
  user,
  name,
}: {
  user: TalentPartnerUser;
  name: string;
}) => {
  return (
    <div data-test="SUPPORT_CONTACTS_PROFILE_HELP">
      <Well>
        <CondensedHeader>Getting the most from your profile</CondensedHeader>
        <Gutter bottom="16px" />
        Axiom recommends focusing on 3-5 areas of deep expertise rather than
        listing every area you've worked in. Clients engage Axiom talent based
        on relevance and depth - a specific, well-crafted profile surfaces more
        consistently than one with 20+ skills and focus areas.
      </Well>
      <Gutter bottom="16px" />
      <CondensedHeader>
        What your Talent Success Partner can help with
      </CondensedHeader>
      <Gutter bottom="8px" />
      <List>
        {helpItems.map((item, index) => (
          <ListItem key={item} name={`HELP_ITEM_${index}`}>
            <Layout>
              <LayoutItem rightGutter="16px">
                <Flashy color="controlSuccessPrimary">
                  <Icon name="circle-check-filled" />
                </Flashy>
              </LayoutItem>
              <LayoutItem fluid>{item}</LayoutItem>
            </Layout>
          </ListItem>
        ))}
      </List>
      <Gutter bottom="16px" />
      <Well>
        <ParagraphHeader>Your Talent Success Partner</ParagraphHeader>
        <Gutter bottom="16px" />
        <Layout position="middle" horizontalGutter="16px">
          <Visible only="largeScreen">
            <ImageCircle
              name="TALENT_PARTNER_IMAGE"
              size="small"
              imageName={name}
            />
          </Visible>
          <div>
            <div data-test="TALENT_PARTNER_NAME">{name}</div>
            <a data-test="TALENT_PARTNER_EMAIL" href={`mailto:${user.email}`}>
              {user.email}
            </a>
          </div>
        </Layout>
      </Well>
    </div>
  );
};
